<template>
    <o-form :title="$t('sandoz.export_job_details')" class="ortic-form-horizontal" ref="form"
            :url="'/api/sandoz/export_jobs/' + $route.params.id +'?include=details'" :enable-save="false">
        <template slot-scope="props">
            <b-row>
                <b-col>
                    <o-form-group :label="$t('core.date')" class="mb-0">
                        <div class="form-control border-0">
                            {{ props.item.created_at | formatDatetime }}
                        </div>
                    </o-form-group>
                    <o-form-group :label="$t('sandoz.status')" class="mb-0">
                        <div class="form-control border-0">
                            {{ props.item.status ? $t('sandoz.' + props.item.status): "" }}
                        </div>
                    </o-form-group>
                </b-col>
                <b-col></b-col>
            </b-row>
        </template>
        <template slot="child" slot-scope="props">
            <o-card class="mt-3" v-for="detail in props.item.details" :key="detail.id"
                    :syncPageTitle="false">
                <b-row>
                    <b-col>
                        <o-form-group :label="$t('sandoz.endpoint')">
                            <div class="form-control border-0 h-auto wb-all">
                                {{ detail.endpoint }}
                            </div>
                        </o-form-group>
                        <o-form-group :label="$t('sandoz.status_code')">
                            <div class="form-control border-0 h-auto">
                                {{ detail.status_code }}
                            </div>
                        </o-form-group>
                        <o-form-group :label="$t('sandoz.error_message')">
                            <div class="form-control border-0 h-auto wb-all">
                                {{ detail.error_message }}
                            </div>
                        </o-form-group>
                        <o-form-group :label="$t('sandoz.payload')" class="mb-0">
                            <div class="form-control border-0 h-auto wb-all">
                                {{ detail.payload }}
                            </div>
                        </o-form-group>
                    </b-col>
                </b-row>
            </o-card>
        </template>
    </o-form>
</template>

<script>
  export default {
      data: () => ({
          stateList: []
      }),
      created() {
          this.stateList = [
              {value: 'running', text: this.$i18n.t('sandoz.running')},
              {value: 'failed', text: this.$i18n.t('sandoz.failed')},
              {value: 'successful', text: this.$i18n.t('sandoz.successful')},
          ]
      }
  }
</script>
